import { useMutation, useQuery } from "@apollo/client";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import { Modal } from "components/layouts";
import { useSearch } from "react-location";
import type { LocationGenerics } from "router/location";
import * as yup from "yup";
import { IssueForm } from "components/forms";
import { GET_ISSUE, UPDATE_ISSUE } from "./apollo";
import { useEffect } from "react";


const validationSchema = yup.object().shape({
  issueBackground: yup.string().required('Required'),
  issueDetails: yup.string().required('Required'),
  issueApplication: yup.string().required('Required'),
  action: yup.string().required('Required'),
  expectation: yup.string().required('Required'),
  classification: yup.string().required('Required'),
  priority: yup.string().required('Required'),
});

export default function UpdateIssueContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const [updateIssue] = useMutation(UPDATE_ISSUE);

  const { data, loading } = useQuery(GET_ISSUE, {
    variables: {
      id: searchParams.id,
    },
    notifyOnNetworkStatusChange: false,
    fetchPolicy: "network-only",
  });

  const form = useFormik<any>({
    initialValues: {
      issueBackground: "",
      issueDetails: "",
      issueApplication: "",
      action: "",
      expectation: "",
      attachments: [],
      classification: "",
      priority: "",
      fullName: "",
      email: "",
      phoneNumber: ""
    },
    validationSchema,
    onSubmit: async (values) => {
      console.log(values)
      await updateIssue({
        variables: {
            id: searchParams.id,
          ...values
        },
      }).then(({ data }) => {
        if (data.updateIssue._id) {
          toast(
            JSON.stringify({
              type: "success",
              title: "Isssue Updated Successfully",
            })
          );
          refetch?.();
          form.resetForm();
        } else {
          toast(
            JSON.stringify({
              type: "error",
              title: "Could not update Issue",
            })
          );
        }
      });
    },
    onReset: () => {
      setOpen(false)
    },
  });

  useEffect(() => {
    if(data?.issue){
        const {__typename, ...remaining} = data?.issue
        form.setValues({
            ...form.values, 
            ...remaining,
            fullName: remaining.contactPerson.fullName,
            email: remaining.contactPerson.email,
            phoneNumber: remaining.contactPerson.phoneNumber,
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.issue])

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      size={"4xl"}
      title='Edit Issue'
      description='Edit this issue'
      renderActions={() => (
        <button
          type='button'
          disabled={form.isSubmitting || !form.isValid}
          onClick={form.submitForm}
          className='w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:bg-primary-400 disabled:cursor-not-allowed focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm'
        >
          {form.isSubmitting ? "Updating..." : "Update Issue"}
        </button>
      )}
    >
      <IssueForm form={form} />
    </Modal>
  );
}
